import { 
  StyledMintComponent,
} from "./Mint.styled"
import FooterMap from './FooterMap'

export default function Impact({ intersectionRef, anchorRef }) {
  return (
    <StyledMintComponent>
      <FooterMap />
    </StyledMintComponent>
  )
}
